(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["madson-collection-filters"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__madsonFilterButtonTargetingBound) return;
    window.__madsonFilterButtonTargetingBound = true;

    function parseSectionMap(raw) {
      // Format: "Label A: group1, group2 | Label B: group3"
      var map = {};
      if (!raw) return map;
      raw.split('|').forEach(function (pair) {
        var idx = pair.indexOf(':');
        if (idx === -1) return;
        var key = pair.slice(0, idx).trim().toLowerCase();
        var val = pair.slice(idx + 1).trim();
        if (key && val) map[key] = val;
      });
      return map;
    }

    function resolveTargets(btn) {
      var raw = (btn.dataset.openGroups || '').trim();
      if (raw && raw !== '(none)') return raw;
      // Fallback: section-level map keyed by button label.
      var section = btn.closest('.madson-collection-filters');
      if (!section) return '';
      var mapRaw = section.dataset.buttonTargetingMap || '';
      if (!mapRaw) return '';
      var label = (btn.dataset.buttonLabel || btn.textContent || '').trim().toLowerCase();
      if (!label) return '';
      var map = parseSectionMap(mapRaw);
      return map[label] || '';
    }

    function syncDrawerGroups(targets) {
      var drawer = document.querySelector('#filters-drawer');
      if (!drawer) return;
      var wrapper = drawer.querySelector('.facets__filters-wrapper');
      if (!wrapper) return;
      var groups = wrapper.querySelectorAll('details.facets__panel');
      groups.forEach(function (group) {
        var summary = group.querySelector('summary');
        if (!summary) return;
        var labelEl = summary.querySelector('.facets__label');
        var rawLabel = labelEl ? labelEl.textContent : summary.textContent;
        var label = (rawLabel || '').trim().toLowerCase();
        if (!label) return;
        var shouldOpen = targets.some(function (t) {
          return label === t || label.indexOf(t) !== -1;
        });
        group.open = shouldOpen;
      });
    }

    function attemptSync(targets, attempts) {
      var drawer = document.querySelector('#filters-drawer');
      var ready = drawer
        && drawer.querySelector('.facets__filters-wrapper details.facets__panel');
      if (ready) {
        syncDrawerGroups(targets);
        return;
      }
      if (attempts <= 0) return;
      setTimeout(function () {
        attemptSync(targets, attempts - 1);
      }, 30);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.madson-filter-button');
      if (!btn) return;
      var raw = resolveTargets(btn);
      if (!raw || !raw.trim()) return;
      var targets = raw
        .split(',')
        .map(function (s) { return s.trim().toLowerCase(); })
        .filter(Boolean);
      if (!targets.length) return;
      requestAnimationFrame(function () {
        attemptSync(targets, 10);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
